module.exports = __webpack_public_path__ + "img/arigato.ec668461.jpeg";